import { Eyebrow, SectionHeading } from "../common/Type";
import { RevealStagger, RevealItem } from "../common/Reveal";
import { whyKratos } from "../../lib/content";

export default function WhyKratos() {
  return (
    <section className="relative py-24 md:py-32" data-testid="section-why-kratos">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <Eyebrow className="mb-5">Why Kratos</Eyebrow>
            <SectionHeading className="!text-3xl md:!text-4xl">
              We design a connected operating model — not a pile of subscriptions.
            </SectionHeading>
            <p className="mt-6 font-body text-sm md:text-base text-kv-grey leading-relaxed">
              Kratos designs and implements the systems that run your business. We do not simply resell software.
            </p>
          </div>

          <RevealStagger className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {whyKratos.map((pillar, i) => (
              <RevealItem key={pillar.title} className="kv-card p-8 md:p-9">
                <span className="block h-1 w-8 bg-kv-electric/80" aria-hidden />
                <h3 className="mt-5 font-display text-xl md:text-2xl font-medium tracking-tight text-kv-off">{pillar.title}</h3>
                <p className="mt-4 font-body text-sm md:text-base text-kv-grey leading-relaxed">{pillar.text}</p>
              </RevealItem>
            ))}
          </RevealStagger>
        </div>
      </div>
    </section>
  );
}
